module.exports = __webpack_public_path__ + "img/10-half-md.da253cd3.jpg";